<template>
  <div>
    <Reassign :headers="headers" 
    :searchUrl="expenseReimbursementList.todoWorks" 
    :transferUrl="expenseReimbursementList.todoWorksPassTo" 
    itemValue="formId"
    />
  </div>
</template>

<script setup lang="ts">
import Reassign from './reassign/reassign.vue';
import { expenseReimbursementList } from './api/ExpenseReimbursementList/ExpenseReimbursementListApi';

definePage({
  meta: {
    action: 'manage',
    subject: 'EXPENSEREIMBURSEMENTREASSIGN',
  },
})

const headers = [
  { title: '核銷單號', key: 'reimburseApplyNo', sortable: true },
  { title: '核銷行程', key: 'activityName', sortable: true },
  { title: '核銷起', 
  key: 'activityStartDate', 
  value: (val: any)=>isEmpty(val.activityStartDate)?'':westernToRoc(val.activityStartDate, "-", "-"), 
  sortable: true 
  },
  { title: '核銷迄', 
  key: 'activityEndDate', 
  value: (val: any)=>isEmpty(val.activityEndDate)?'':westernToRoc(val.activityEndDate, "-", "-"), 
  sortable: true 
  },
  { title: '申請人', key: 'applyEmpNo', sortable: true },
  { title: '申請時間', key: 'applyTime', sortable: true },
];

</script>

<style>

</style>